module.exports = __webpack_public_path__ + "img/t-logo.b5a31e65.svg";